import { ClientActionEventIdentities, } from "./ClientActionEvent.js";
import { UserSessionStartEventIdentities, } from "./UserSessionStartEvent.js";
const CLIENT_ACTION_EVENT_SCHEMA_URL = "iglu:com.boatsetter.analytics.v1/ClientActionEvent/jsonschema/1-0-3";
const USER_SESSION_EVENT_SCHEMA_URL = "iglu:com.boatsetter.analytics.v1/UserSessionStartEvent/jsonschema/1-0-3";
export const AllEventIdentities = Object.assign(Object.assign({}, ClientActionEventIdentities), UserSessionStartEventIdentities);
export const EVENT_SCHEMA_TO_IDENTITIES = {
    [CLIENT_ACTION_EVENT_SCHEMA_URL]: ClientActionEventIdentities,
    [USER_SESSION_EVENT_SCHEMA_URL]: UserSessionStartEventIdentities,
};
